import React from 'react';

const MicrophoneGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h144v144H0z" />
            <g fillRule="nonzero">
                <path
                    fill="#FFF"
                    d="M90.217 76.736c0 7.502-6.095 13.585-13.612 13.585h-10.21c-7.517 0-13.612-6.083-13.612-13.585V39.377c0-7.502 6.095-13.585 13.612-13.585h10.21c7.517 0 13.612 6.083 13.612 13.585v37.359z"
                />
                <path
                    fill="#363A43"
                    d="M88.88 76.736V39.377c0-6.757-5.494-12.24-12.275-12.24h-10.21c-6.781 0-12.275 5.483-12.275 12.24v37.359c0 6.757 5.494 12.24 12.275 12.24h10.21c6.781 0 12.275-5.483 12.275-12.24zm2.674 0c0 8.247-6.696 14.93-14.95 14.93H66.396c-8.253 0-14.95-6.683-14.95-14.93V39.377c0-8.247 6.697-14.929 14.95-14.929h10.21c8.253 0 14.95 6.682 14.95 14.93v37.358z"
                />
                <path
                    fill="#F16932"
                    d="M63.478 103.764h16.044V90.321H63.478z"
                />
                <path
                    fill="#363A43"
                    d="M63.478 105.108a1.34 1.34 0 0 1-1.337-1.344V90.321a1.34 1.34 0 0 1 1.337-1.345h16.044a1.34 1.34 0 0 1 1.337 1.345v13.443a1.34 1.34 0 0 1-1.337 1.344H63.478zm1.337-2.688h13.37V91.665h-13.37v10.755z"
                />
                <path fill="#F16932" d="M68.826 119v-15.236h7.131V119" />
                <path
                    fill="#363A43"
                    d="M69.272 105.108V119h-2.674v-15.236a1.34 1.34 0 0 1 1.337-1.344h7.13a1.34 1.34 0 0 1 1.337 1.344V119h-2.674v-13.892h-4.456zM91.109 62.09v2.688H75.957V62.09zM91.109 68.363v2.689H75.957v-2.689zM91.109 74.637v2.688H75.957v-2.688zM91.109 55.816v2.689H75.957v-2.689zM91.109 49.542v2.689H75.957v-2.689zM91.109 43.269v2.689H75.957v-2.689zM67.935 62.09v2.688H52.783V62.09zM67.935 68.363v2.689H52.783v-2.689zM67.935 74.637v2.688H52.783v-2.688zM67.935 55.816v2.689H52.783v-2.689zM67.935 49.542v2.689H52.783v-2.689zM67.935 43.269v2.689H52.783v-2.689zM70.163 25.792h2.674v13.444h-2.674zM76.402 25.792h2.674v13.444h-2.674zM63.924 25.792h2.674v13.444h-2.674z"
                />
            </g>
        </g>
    </svg>
);

MicrophoneGraphicSvg.displayName = 'MicrophoneGraphicSvg';
export default MicrophoneGraphicSvg;
